import React from 'react';
import { TopBar } from '../../components/layout/TopBar';
import { Header } from '../../components/layout/Header';
import { Navigation } from '../../components/layout/Navigation';
import { MobileStickyBar } from '../../components/layout/MobileStickyBar';
import { Footer } from '../../components/layout/Footer';
import { useScreenInit } from '../../useScreenInit';
import { Building2, Package, Home, Phone, ArrowRight } from 'lucide-react';
export function Catalog() {
  useScreenInit();
  return <div className="min-h-screen flex flex-col bg-brand-background" data-id="element-955">
      <TopBar data-id="element-956" />
      <Header data-id="element-957" />
      <Navigation data-id="element-958" />

      <main className="flex-grow" data-id="element-959">
        {/* Hero */}
        <section className="bg-white border-b border-brand-border py-16 lg:py-24" data-id="element-960">
          <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-961">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-goldSoft text-brand-charcoal text-xs font-bold tracking-wide mb-4 uppercase border border-brand-gold/30" data-id="element-962">
              Browse Our Products
            </span>
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-brand-charcoal mb-6 leading-tight" data-id="element-963">
              Catalog
            </h1>
            <p className="text-lg lg:text-xl text-brand-muted max-w-3xl mx-auto leading-relaxed" data-id="element-964">
              Explore our residential and commercial mailbox systems, cluster
              boxes, and exterior accents. Choose a category below to start
              browsing, or call us to find the right product for your project.
            </p>
          </div>
        </section>

        {/* Catalog hub */}
        <section className="py-16 lg:py-24 bg-brand-background border-b border-brand-border" data-id="element-965">
          <div className="max-w-7xl mx-auto px-4" data-id="element-966">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-967">
              <a href="/6m8/commercial-mailboxes-lockers.html" className="group bg-white rounded-2xl border border-brand-border p-8 hover:border-brand-maroon transition-colors shadow-sm flex flex-col" data-id="element-968">
                <div className="w-14 h-14 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center mb-6" data-id="element-969">
                  <Building2 size={26} data-id="element-970" />
                </div>
                <h2 className="text-xl font-bold text-brand-charcoal mb-2 group-hover:text-brand-maroon transition-colors" data-id="element-971">
                  Commercial Mailboxes & Lockers
                </h2>
                <p className="text-brand-muted text-sm flex-grow mb-4" data-id="element-972">
                  Cluster Box Units (CBUs), 4C systems, and multi-tenant
                  mailboxes for developments and commercial buildings.
                </p>
                <span className="inline-flex items-center gap-1 text-brand-maroon font-semibold text-sm" data-id="element-973">
                  Browse category{' '}
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-974" />
                </span>
              </a>

              <a href="/m8/4C16D-20-D--versatile-4c-depot-16h-20-door-package.html" className="group bg-white rounded-2xl border border-brand-border p-8 hover:border-brand-maroon transition-colors shadow-sm flex flex-col" data-id="element-975">
                <div className="w-14 h-14 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center mb-6" data-id="element-976">
                  <Package size={26} data-id="element-977" />
                </div>
                <h2 className="text-xl font-bold text-brand-charcoal mb-2 group-hover:text-brand-maroon transition-colors" data-id="element-978">
                  Featured 4C System
                </h2>
                <p className="text-brand-muted text-sm flex-grow mb-4" data-id="element-979">
                  See a sample product detail page — the Versatile 4C Depot 16H
                  20-Door Package — with options and specifications.
                </p>
                <span className="inline-flex items-center gap-1 text-brand-maroon font-semibold text-sm" data-id="element-980">
                  View product{' '}
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-981" />
                </span>
              </a>

              <a href="/" className="group bg-white rounded-2xl border border-brand-border p-8 hover:border-brand-maroon transition-colors shadow-sm flex flex-col" data-id="element-982">
                <div className="w-14 h-14 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center mb-6" data-id="element-983">
                  <Home size={26} data-id="element-984" />
                </div>
                <h2 className="text-xl font-bold text-brand-charcoal mb-2 group-hover:text-brand-maroon transition-colors" data-id="element-985">
                  Residential & Street Signs
                </h2>
                <p className="text-brand-muted text-sm flex-grow mb-4" data-id="element-986">
                  Start from the homepage to explore residential mailboxes,
                  decorative posts, and street sign systems.
                </p>
                <span className="inline-flex items-center gap-1 text-brand-maroon font-semibold text-sm" data-id="element-987">
                  Go to homepage{' '}
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-988" />
                </span>
              </a>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 lg:py-20 bg-white text-center" data-id="element-989">
          <div className="max-w-3xl mx-auto px-4" data-id="element-990">
            <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-991">
              Not sure which product you need?
            </h2>
            <p className="text-brand-muted mb-8" data-id="element-992">
              Our team can help you identify the right model, confirm USPS
              compliance, and provide a free estimate for your project.
            </p>
            <a href="tel:301-620-7585" className="inline-flex items-center justify-center gap-2 bg-brand-maroon hover:bg-brand-maroonDark text-white px-8 py-3.5 rounded-md font-bold transition-colors shadow-sm" data-id="element-993">
              <Phone size={18} data-id="element-994" /> Call 301-620-7585
            </a>
          </div>
        </section>
      </main>

      <Footer data-id="element-995" />
      <MobileStickyBar data-id="element-996" />
    </div>;
}